module.exports = __webpack_public_path__ + "img/c9da7a7af86b8757f6a0c9dfdcb68ffd.png";